import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Dropdown/Dropdown.Button.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { PopoverButton } from "@headlessui/react";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "button";
var DropdownButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(PopoverButton, __spreadProps(__spreadValues({
    ref,
    as: Component
  }, rest), {
    className: clsx(className),
    children
  }));
});
var StoryDropdownButton = args => /* @__PURE__ */jsx(DropdownButton, __spreadValues({}, args));
var Dropdown_Button_default = DropdownButton;
export { StoryDropdownButton, Dropdown_Button_default };